import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * ClikArt that was decomposed from an NSD keeps its art id in `imageId`; the editor keeps it in
 * `pezId` (with an empty `imageId`), which is what tells a ClikArt fill from a photo fill
 * (`resolvePlacedClikArtId`, `resolvePlacedPhotoIdentity`) and what the backend writes back as the
 * `II` attribute. A template is decomposed from NSD, so its ClikArt arrives the first way; move the
 * id so it is read as the ClikArt it is, not looked up as a photo.
 */
export function normalizeTemplateClikArtFill(shape: ShapeData): ShapeData {
  const fill = shape.photoFill

  if (!fill || fill.imageType.toLowerCase() !== 'clikart' || !fill.imageId || fill.pezId) {
    return shape
  }

  return { ...shape, photoFill: { ...fill, imageId: '', pezId: fill.imageId } }
}
